<template>
  <div class="footer-page-container">
    <div class="page-content">
      <h1 class="page-title">关于英才计划</h1>
      <div class="page-body">
        <section class="talent-plan-intro">
          <h2>计划背景</h2>
          <p>随着经济社会的快速发展，行业对高端人才的需求日益增长。为了满足这一需求，我们推出了"英才计划"，旨在培养一批具有国际视野、创新能力和实践经验的高素质人才，为行业发展注入新的活力。</p>
        </section>
        
        <section class="talent-plan-objectives" style="margin-top: 30px;">
          <h2>计划目标</h2>
          <ul class="objective-list">
            <li>培养具有扎实专业知识和实践能力的高端人才</li>
            <li>提升学员的创新思维和解决实际问题的能力</li>
            <li>促进学员的职业发展，实现个人价值</li>
            <li>为行业输送高素质的专业人才，推动行业进步</li>
          </ul>
        </section>
        
        <section class="talent-plan-features" style="margin-top: 30px;">
          <h2>计划特色</h2>
          <div class="features-grid">
            <div class="feature-item">
              <h3>定制化培养方案</h3>
              <p>根据学员的实际情况和职业目标，制定个性化的培养方案</p>
            </div>
            <div class="feature-item">
              <h3>名师团队授课</h3>
              <p>由行业专家、资深讲师组成的教学团队，提供专业指导</p>
            </div>
            <div class="feature-item">
              <h3>实战项目训练</h3>
              <p>通过实际项目训练，提升学员的实践能力和解决问题的能力</p>
            </div>
            <div class="feature-item">
              <h3>就业推荐服务</h3>
              <p>为优秀学员提供就业推荐服务，帮助他们实现职业发展目标</p>
            </div>
          </div>
        </section>
        
        <section class="talent-plan-advantages" style="margin-top: 30px;">
          <h2>计划优势</h2>
          <ul class="advantage-list">
            <li><strong>专业的教学团队：</strong>由行业专家、资深讲师组成，拥有丰富的教学经验和实践经验</li>
            <li><strong>先进的教学方法：</strong>采用案例教学、项目驱动等先进教学方法，提高教学效果</li>
            <li><strong>完善的服务体系：</strong>从报名咨询到就业推荐，提供全方位的服务支持</li>
            <li><strong>广泛的行业资源：</strong>与众多企业建立了合作关系，为学员提供实习和就业机会</li>
            <li><strong>良好的学习环境：</strong>提供舒适的学习环境和先进的教学设施</li>
          </ul>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutTalentPlan',
  data() {
    return {
      // 页面数据
    }
  },
  methods: {
    // 页面方法
  }
}
</script>

<style scoped lang="scss">
.footer-page-container {
  max-width: 1200px;
  margin: 100px auto 0;
  padding: 40px 20px;
}

.page-content {
  background: #fff;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.page-title {
  font-size: 24px;
  font-weight: 600;
  color: #3E2CCD;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e5e7eb;
}

.page-body {
  font-size: 16px;
  line-height: 1.8;
  color: #666;
  
  p {
    margin-bottom: 15px;
  }
}
</style>